import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { HashLoader } from "react-spinners";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";

import { COLORS } from "../../utils/colors";
import { MainButton } from "../../components/MainButton";
import { updateEvent } from "../../api/events";
import { ICONS } from "../../utils/icons";

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 250,
      minWidth: 250,
      fontFamily: "AuthenticSans90",
    },
  },
};

export const CreateDiscountDialog = ({
  openPopup,
  setOpenPopup,
  discounts,
  handleSnackbar,
  event,
  setEvent,
}) => {
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      code: "",
      discount_type: "",
      discount_amount: "",
      max_usage: "",
    },
    validationSchema: yup.object({
      code: yup.string("Enter code").required("Required"),
      discount_type: yup.string("Enter type").required("Required"),
      discount_amount: yup.string("Enter amount").required("Required"),
      max_usage: yup.number("Enter max usage").required("Required"),
    }),
    onSubmit: (values) => {
      handleFormSubmit(values);
    },
  });

  const handleClose = () => {
    setOpenPopup(false);
  };

  const handleFormSubmit = async (values) => {
    try {
      setLoading(true);

      const confirmAction = window.confirm(
        "Are you sure you want to take this action?"
      );

      if (!confirmAction) {
        setLoading(false);
        return;
      }

      let updates = {};
      updates["ticket_discounts"] = discounts || {};
      updates.ticket_discounts[`${values.code}`] = values;

      const { data, error } = await updateEvent(updates, event);

      if (data) {
        setEvent(data);
      }

      if (error) {
        handleSnackbar(error, "error");
        setLoading(false);
        return;
      }

      handleSnackbar("Ticket discount updated successfully", "success");
      handleClose();
      setLoading(false);
    } catch (error) {
      console.log("error: ", error);
      handleSnackbar(error, "error");
      setLoading(false);
    }
  };

  return (
    <Dialog open={openPopup} onClose={() => handleClose()}>
      <DialogContent
        sx={{
          width: "500px",
          padding: "40px",
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <form style={{ width: "500px" }}>
          <h2 style={{ width: "-webkit-fill-available", marginBottom: "20px" }}>
            {ICONS.plusBlack25} Create new discount code
          </h2>
          <p style={{ width: "-webkit-fill-available", marginBottom: "20px" }}>
            Required Fields
          </p>
          <div className="two-columns-fields-container">
            <div style={{ width: "-webkit-fill-available" }}>
              <div className="field-container">
                <p
                  id="subheader"
                  style={{
                    margin: "0px 0px 3px",
                    alignSelf: "center",
                  }}
                >
                  Code*
                </p>
                <TextField
                  fullWidth
                  disabled={loading}
                  size="small"
                  className="input"
                  name="code"
                  placeholder="not set"
                  value={formik.values.code}
                  onChange={formik.handleChange}
                  error={formik.touched.code && Boolean(formik.errors.code)}
                  helperText={formik.touched.code && formik.errors.code}
                  sx={{
                    "& label": {
                      paddingLeft: (theme) => theme.spacing(1),
                    },
                    "& fieldset": {
                      borderRadius: "6px",
                      border: `2px solid #f0f1f5`,
                      transition: ".2s ease-in-out all",
                    },
                    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "#f0f1f5",
                      },
                    "& .MuiOutlinedInput-input:hover": {
                      cursor: loading && "not-allowed",
                    },
                  }}
                />
              </div>
              <div className="field-container">
                <p
                  id="subheader"
                  style={{
                    margin: "0px 0px 3px",
                    alignSelf: "center",
                  }}
                >
                  Discount amount*
                </p>
                <TextField
                  fullWidth
                  disabled={loading}
                  size="small"
                  className="input"
                  name="discount_amount"
                  type="number"
                  inputProps={{ min: 1, max: 100 }}
                  placeholder="not set"
                  value={formik.values.discount_amount}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.discount_amount &&
                    Boolean(formik.errors.discount_amount)
                  }
                  helperText={
                    formik.touched.discount_amount &&
                    formik.errors.discount_amount
                  }
                  sx={{
                    "& label": {
                      paddingLeft: (theme) => theme.spacing(1),
                    },
                    "& fieldset": {
                      borderRadius: "6px",
                      border: `2px solid #f0f1f5`,
                      transition: ".2s ease-in-out all",
                    },
                    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "#f0f1f5",
                      },
                    "& .MuiOutlinedInput-input:hover": {
                      cursor: loading && "not-allowed",
                    },
                  }}
                />
              </div>
            </div>
            <div style={{ width: "-webkit-fill-available" }}>
              <div className="field-container">
                <p
                  id="subheader"
                  style={{
                    margin: "0px 0px 3px",
                    alignSelf: "center",
                  }}
                >
                  Type*
                </p>
                <Select
                  size="small"
                  name="discount_type"
                  value={formik.values.discount_type}
                  onChange={formik.handleChange}
                  input={<OutlinedInput label="Name" />}
                  MenuProps={MenuProps}
                  style={{
                    maxWidth: "100px",
                    minWidth: "-webkit-fill-available",
                  }}
                  error={
                    formik.touched.discount_type &&
                    Boolean(formik.errors.discount_type)
                  }
                  sx={{
                    "& label": {
                      paddingLeft: (theme) => theme.spacing(1),
                    },
                    "& fieldset": {
                      borderRadius: "6px",
                      border: `2px solid #f0f1f5`,
                      transition: ".2s ease-in-out all",
                    },
                    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "#f0f1f5",
                      },
                    "& .MuiOutlinedInput-input:hover": {
                      cursor: loading && "not-allowed",
                    },
                  }}
                >
                  <MenuItem value={"percentage"}>Percentage Discount</MenuItem>
                </Select>
              </div>
              <div className="field-container">
                <p
                  id="subheader"
                  style={{
                    margin: "0px 0px 3px",
                    alignSelf: "center",
                  }}
                >
                  Maximum usage*
                </p>
                <TextField
                  fullWidth
                  disabled={loading}
                  size="small"
                  className="input"
                  name="max_usage"
                  type="number"
                  inputProps={{ min: 0 }}
                  placeholder="not set"
                  value={formik.values.max_usage}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.max_usage && Boolean(formik.errors.max_usage)
                  }
                  helperText={
                    formik.touched.max_usage && formik.errors.max_usage
                  }
                  sx={{
                    "& label": {
                      paddingLeft: (theme) => theme.spacing(1),
                    },
                    "& fieldset": {
                      borderRadius: "6px",
                      border: `2px solid #f0f1f5`,
                      transition: ".2s ease-in-out all",
                    },
                    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "#f0f1f5",
                      },
                    "& .MuiOutlinedInput-input:hover": {
                      cursor: loading && "not-allowed",
                    },
                  }}
                />
              </div>
            </div>
          </div>
          <DialogActions>
            <MainButton
              disabled={loading}
              color={COLORS.black}
              shadowColor={"transparent"}
              textColor={COLORS.white}
              textHoverColor={COLORS.lightGrey}
              hoverColor={COLORS.black}
              textAlignment={"center"}
              onClickAction={() => formik.handleSubmit()}
              width={"fit-content"}
            >
              {loading ? (
                <>
                  <HashLoader size={20} color={COLORS.grey} /> Save
                </>
              ) : (
                "Save"
              )}
            </MainButton>
          </DialogActions>
        </form>
      </DialogContent>
    </Dialog>
  );
};
